<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search >
        <search-box class="search-box">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="80px" size="mini">
            <el-form-item label="区域" prop="orgName">
              <el-input v-model="searchForm.orgName"></el-input>
            </el-form-item>
            <el-form-item label="经销商名称" prop="customerName">
              <el-input v-model="searchForm.customerName"></el-input>
            </el-form-item>
            <el-form-item label="商户名称" prop="shopName">
              <el-input v-model="searchForm.shopName"></el-input>
            </el-form-item>
            <el-form-item label="支付方式" prop="payWay">
              <el-select v-model="searchForm.payWay">
                <el-option label="全部" value=""></el-option>
                <el-option label="微信支付" value="微信支付"></el-option>
                <el-option label="银联支付" value="银联支付"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="核对时间" prop="updatedTime">
              <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item> -->
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportFile">导出</el-button>
        </template>
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="maxTableHeight">
          <el-table-column prop="seqId" label="序号" width="50"></el-table-column>
          <el-table-column prop="orgName" label="区域名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="customerName" label="经销商名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="shopName" label="商户名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="businessStatus" label="经销商经营状态" width="120"></el-table-column>
          <el-table-column prop="payWay" label="支付方式" width="120"></el-table-column>
          <el-table-column prop="payWayUpdateBy" label="操作人" width="120"></el-table-column>
          <el-table-column prop="payWayUpdateTime" label="操作时间" align="center"width="180"></el-table-column>
          <el-table-column label="操作" align="center" width="130">
            <template v-slot="{row}">
              <el-button type="text" size="small" @click="changePayWay(row)">
                更换支付方式
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <change-pay-way-dialog 
      :isShowChangePayWayDialog.sync="isShowChangePayWayDialog"
      :changePayWayParams="changePayWayParams"
      @changePayWaySuccess="onSearch"
    />
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from 'moment';
import changePayWayDialog from "./components/change-pay-way-dialog";
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {
    changePayWayDialog
  },
  data() {
    return {
      searchForm: {
        orgName: "",
        customerName: "",
        payWay: "",
        shopName: ""
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      isShowChangePayWayDialog: false,
      changePayWayParams: {}
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
          dateCode:  moment('2025-02-20').format("YYYYMMDD")
        },
      };
      this.$api.dataReport
        .queryCustomerPayWayList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    changePayWay(row) {
      const { customerId,payWay } = row
      this.changePayWayParams = {
        boolAllCustomer: 0,
        customerId,
        payWay: payWay == '银联支付' ? 0 : 1
      }
      this.isShowChangePayWayDialog = true
    },
    exportFile() {
      const params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("queryCustomerPayWayList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .date-input  {
    width 220px !important
  }
}
</style>
